import React from "react";
import { ClientRowData, ClientAdjustmentRecord } from "../types";
import { parseNum } from "../utils";

interface SaveConfirmationModalProps {
    showSave: boolean;
    setShowSave: (show: boolean) => void;
    cycleYear: number;
    dirtyCount: number;
    dirtyClients: ClientRowData[];
    savedAdjustments: Record<number, ClientAdjustmentRecord>;
    drafts: Record<number, string>;
    saveComment: string;
    setSaveComment: (v: string) => void;
    handleConfirmSave: () => void;
    isSubmitting: boolean;
}

export const SaveConfirmationModal: React.FC<SaveConfirmationModalProps> = ({
    showSave,
    setShowSave,
    cycleYear,
    dirtyCount,
    dirtyClients,
    savedAdjustments,
    drafts,
    saveComment,
    setSaveComment,
    handleConfirmSave,
    isSubmitting,
}) => {
    if (!showSave) return null;

    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
            <div style={{ background: "#fff", borderRadius: "14px", width: "520px", maxWidth: "92vw", padding: "26px", maxHeight: "88vh", overflowY: "auto" }}>
                <div style={{ fontSize: "17px", fontWeight: 700, color: "#1e293b" }}>
                    Confirmar reajustes — Ciclo {cycleYear}
                </div>
                <div style={{ fontSize: "13.5px", color: "#64748b", marginTop: "6px", lineHeight: 1.5 }}>
                    Você está atualizando o reajuste do ciclo <strong>{cycleYear}</strong> para <strong>{dirtyCount}</strong> cliente(s).
                </div>

                <div style={{ border: "1px solid #e2e8f0", borderRadius: "10px", marginTop: "16px", maxHeight: "200px", overflowY: "auto" }}>
                    {dirtyClients.map((c) => {
                        const currentSaved = savedAdjustments[c.clientId];
                        const currentStr = currentSaved ? `${currentSaved.adjustment.toFixed(2).replace(".", ",")}%` : "sem reajuste";
                        const draftVal = parseNum(drafts[c.clientId]);
                        const draftStr = `${draftVal.toFixed(2).replace(".", ",")}%`;

                        return (
                            <div key={c.clientId} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderBottom: "1px solid #f1f5f9" }}>
                                <div>
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>{c.clientFantasyName}</span>
                                    <span style={{ fontSize: "11px", color: "#94a3b8", marginLeft: "6px" }}>{c.clientCodeCnx}</span>
                                </div>
                                <div style={{ fontSize: "13px", color: "#64748b" }}>
                                    {currentStr} <span style={{ color: "#cbd5e1" }}>→</span> <strong style={{ color: "#0d9488" }}>{draftStr}</strong>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div style={{ marginTop: "16px" }}>
                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                        Justificativa / Comentário (obrigatório) *
                    </label>
                    <textarea
                        placeholder="Ex: Reajuste anual contratual ciclo 2026 - IPCA"
                        value={saveComment}
                        onChange={(e) => setSaveComment(e.target.value)}
                        style={{ width: "100%", padding: "10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", fontFamily: "inherit", resize: "vertical", minHeight: "76px", outline: "none" }}
                    />
                    <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "5px" }}>
                        Aplicado a todos os clientes deste lote. Comentários individuais definidos por cliente têm prioridade.
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "22px" }}>
                    <button
                        onClick={() => setShowSave(false)}
                        disabled={isSubmitting}
                        style={{ background: "#fff", color: "#334155", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "10px 16px", fontSize: "13.5px", fontWeight: 600, cursor: "pointer" }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirmSave}
                        disabled={isSubmitting || !saveComment.trim()}
                        style={{
                            background: saveComment.trim() ? "#0d9488" : "#cbd5e1",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 18px",
                            fontSize: "13.5px",
                            fontWeight: 600,
                            cursor: saveComment.trim() ? "pointer" : "not-allowed",
                        }}
                    >
                        {isSubmitting ? "Salvando..." : `Salvar ${dirtyCount} reajuste(s)`}
                    </button>
                </div>
            </div>
        </div>
    );
};
